import { render, staticRenderFns } from "./ImportFileCard.vue?vue&type=template&id=8180eecc&scoped=true"
import script from "./ImportFileCard.vue?vue&type=script&lang=js"
export * from "./ImportFileCard.vue?vue&type=script&lang=js"
import style0 from "./ImportFileCard.vue?vue&type=style&index=0&id=8180eecc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8180eecc",
  null
  
)

export default component.exports